<template>
    <div>
        <svg :width="iconSize" :height="iconSize" viewBox="0 0 24 14" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M23.3747 8.36492C23.3698 7.45593 22.697 6.69434 21.8087 6.59215C20.8037 6.52522 19.8712 7.12583 19.5014 8.07831C19.2888 7.24091 18.5748 6.63451 17.7265 6.57092C16.8779 6.54232 16.0907 7.01923 15.7115 7.79169V6.88938H13.9993L13.9367 6.21L13.1328 0H10.1468L7.69337 7.314L5.3965 0H2.43146L0.5 13.8H3.48593L4.44644 5.94462L7.04607 13.7575H8.19451L11.0552 5.80662L11.8695 13.8H15.7115V10.2438C15.6244 9.67358 15.7843 9.09288 16.15 8.65154C16.5154 8.37554 17.549 8.52415 17.549 10.1377V13.8H19.5744V10.1377C19.5711 9.77843 19.6203 9.42066 19.7206 9.07615C19.919 8.418 21.4119 7.85538 21.4119 10.1377V13.8H23.5V9.74492C23.4964 9.28216 23.4545 8.82054 23.3747 8.36492Z"
                :fill="color" 
            />
        </svg>
    </div>
</template>

<script>
export default {
    name: 'IconSvgNYSSCPAMentormatch',
    props: {
        color: {
            type: String,
            default: '#000000',
        },
        size: {
            type: Number,
            default: null
        }
    },
    computed: {
        iconSize() {
            return this.size ? `${this.size}px` : '44px'
        }
    }
};
</script>

<style scoped></style>